import { FunctionComponent, useRef } from "react";
import { TeamMember as TeamMemberProps } from "../../types";
import { toStateObject, scrollToRef } from "../../lib/helpers";
import { media } from "../../../styles/styles";
import TeamMember from "../blockComponents/TeamMember";
import styled from "styled-components";
import {Grid, Card} from "@mui/material";
import ArrowRightIcon from "../icons/ArrowRightIcon";
import Image from "next/image";

interface Props {
  teamMembers: TeamMemberProps[];
}
const ArrowDown = styled(ArrowRightIcon)`
  transform: rotate(90deg);
  path {
    fill: #e55934;
  }
`;
const NavigationItem = styled(Card)`
  text-align: center;
  height: 250px;
  cursor: pointer;
  img {
    max-width: 100%;
    ${media.tablet`
    max-width: 75%;
  `};
  }
  svg {
    transition: margin 200ms;
  }
  &:hover {
    svg {
      margin-top: 10px;
    }
  }
`;
const Break = styled.hr`
  border-top: 1px solid #e6e6e6;
  &:last-of-type {
    border-top: none;
  }
`;
const TeamMembers: FunctionComponent<Props> = ({ teamMembers }) => {
  const states = [
    "New South Wales",
    "Queensland",
    "Victoria",
   // "Western Australia", // if readded change sm={4} to sm={3}
  ];

  const order = [
    "General Manager",
  ];

  const stateRefs = {}

  const statesObjects = states.map((stateName) => ({
    ...toStateObject(stateName, false)
  }));
  const teamMembersByState = states.map((stateName) => ({
    name: stateName,
    teamMembers: teamMembers
      .filter((teamM) => teamM.state === stateName)
      .sort((a, b) => order.indexOf(b?.positions?.[0]) - order.indexOf(a?.positions?.[0])),
  }));

  const ScrollToNavigationItem = ({state}) => {
    const ref = useRef(null)
    stateRefs[state.name] = ref
    const handleClick = () => scrollToRef(ref)

    return (
        <NavigationItem
            elevation={0}
            onClick={handleClick}
        >
          <div>
            <Image src={`/images/${state.shortName}.png`}  alt={`Image for ${state.shortName}`}/>
          </div>
          <h3>{state.longName}</h3>
          <ArrowDown />
        </NavigationItem>
    )
  }

  return (
    <>
      <Grid container alignContent="space-between">
        {statesObjects.map((state) => (
          <Grid item sm={4} xs={6} key={state.shortName}>
            <ScrollToNavigationItem state={state} />
          </Grid>
        ))}
      </Grid>
      {teamMembersByState.map((state, index) =>
        state.teamMembers.length ? (
          <div ref={stateRefs[state.name]} key={state.name}>
            <h2>{state.name}</h2>
            {state.teamMembers.map((teamMember) => (
              <TeamMember teamMember={teamMember} key={teamMember.fullName} />
            ))}
            <Break />
          </div>
        ) : null
      )}
    </>
  );
};
export default TeamMembers;
